import * as Sentry from "@sentry/react";

import { rooFetch } from "../../api/common/rooFetch";

export const getSingleToggleService = async ({
  userId,
  notificationCode,
  hospitalId,
}: {
  userId: number | string;
  notificationCode: number;
  hospitalId?: number | string;
}) => {
  try {
    const response = await rooFetch(
      window.RooConfig.NOTIFICATION_SETTINGS_API_URL +
        `/api/notification/getSingleSetting?` +
        new URLSearchParams({
          userId: String(userId),
          notificationTypeId: String(notificationCode),
          hospitalId: hospitalId ? String(hospitalId) : "",
        })
    );

    if (response.status !== 200) {
      Sentry.captureException("error from NotificationUtils > getSingleToggleService", {
        extra: { response: response },
      });
      throw new Error("something went wrong");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    Sentry.captureException(error);
  }
};

export const updateSingleToggleService = async ({
  userId,
  notificationCode,
  hospitalId,
  config,
}: {
  userId: number | string;
  notificationCode: number;
  hospitalId?: number | string;
  config: {
    smsEnabled: boolean;
    emailEnabled: boolean;
    pushEnabled: boolean;
  };
}) => {
  const response = await rooFetch(
    window.RooConfig.NOTIFICATION_SETTINGS_API_URL + `/api/notification/notificationToggles`,
    {
      method: "PUT",
      body: JSON.stringify({
        notificationTypeId: notificationCode,
        userId,
        hospitalId,
        smsEnabled: config.smsEnabled,
        emailEnabled: config.emailEnabled,
        pnEnabled: config.pushEnabled,
      }),
    }
  );
  if (response.status !== 200) {
    Sentry.captureException("error from NotificationUtils > updateSingleToggleService", {
      extra: { response: response },
    });
    throw new Error("something went wrong");
  }
  const data = await response.text();
  return data;
};
